import * as Yup from 'yup'

export const contractorHireSchema = Yup.object({
    joining_date:Yup.string().required('INPUT.VALIDATION.HIRECANDIDATE.JOINING.DATE'),
    employment_type:Yup.string().required('INPUT.VALIDATION.HIRECANDIDATE.EMPLOYMEN.TYPE'),
      destination:Yup.string().required('INPUT.VALIDATION.HIRECANDIDATE.DESTINATION'),
      rate:Yup.string().required('INPUT.VALIDATION.HIRECANDIDATE.HOURLY.RATE'),
})